module.exports = __webpack_public_path__ + "img/fj.a9c4382.svg";